<template>
  <nav class="nav-main" :class="[ isSticky ? 'sticky-top' : 'remove-sticky-top']">
    <ul class="nav-list">
      <li
        class="nav-item"
        :key="index"
        v-for="(item, index) in arrMenu"
        :class="[ currentRouteName == item.route_name ? 'active' :'' ]"
      >
        <a
          data-action="open_tab"
          :data-tab="getDataTab(item)"
          href="javascript:;"
          @click="redirectLink(item)"
        >{{item.name}}</a>
      </li>
    </ul>
  </nav>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    arrMenu: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isSticky: false
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("global", ["saveMarketActiveTab"]),
    async redirectLink(obj) {
      if (obj.route_scroll >= 0) {
        window.scrollTo(0, obj.route_scroll);
      }

      if (obj.route_replace) {
        this.$router.replace(obj.route_obj);
      } else {
        this.$router.push(obj.route_obj);
      }

      if (obj.remember_router) {
        await this.saveMarketActiveTab(obj.route_name);
      }
    },
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      currentScrollPosition > 0 ? (this.isSticky = true) : (this.isSticky = false);
    },
    getDataTab({ name }) {
      switch (name) {
        case "OVERVIEW":
          return "fund_overview";
        case "RETURN":
          return "fund_performance";
        case "PORT":
          return "fund_portfolio";
        case "FEES":
          return "fund_fee";

        case "FUNDS":
          return "market_fund";
        case "STOCKS":
          return "market_stock";
        case "INDICES":
          return "market_index";

        default:
          return "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-main {
  position: fixed;
  top: 0;
  width: 100%;
  background: $color-white;
  z-index: 11;
  .nav-list {
    overflow-y: hidden;
    overflow-x: auto;
    list-style: none;
    padding: 0;
    margin: 0;
    border-bottom: 1px solid $color-border;
    display: flex;
    .nav-item {
      text-align: center;
      flex: 1 1 auto;
      min-width: 85px;
      @include finRippleBtn($color-white, $color-white, $color-light-grey-2);
      a {
        padding: 12px 0;
        display: block;
        text-decoration: none;
        color: $color-secondary-text;
        @extend %font-size-s;
      }
    }
    .active {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        -webkit-animation: widthAnimate 0.3s; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: widthAnimate 0.3s; /* Firefox < 16 */
        -ms-animation: widthAnimate 0.3s; /* Internet Explorer */
        -o-animation: widthAnimate 0.3s; /* Opera < 12.1 */
        animation: widthAnimate 0.3s;
        background-color: $color-orange-finno;
        height: 4px;
      }
      a {
        color: $color-normal-text;
        font-weight: bold;
      }
    }
  }
}
.sticky-top {
  position: sticky;
  top: 0;
}
.remove-sticky-top {
  position: relative;
}
@keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Firefox < 16 */
@-moz-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Internet Explorer */
@-ms-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Opera < 12.1 */
@-o-keyframes widthAnimate {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>